import { render } from "./ReplyBoxComponent.vue?vue&type=template&id=14a0a6e1&scoped=true"
import script from "./ReplyBoxComponent.vue?vue&type=script&lang=js"
export * from "./ReplyBoxComponent.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./ReplyBoxComponent.vue?vue&type=style&index=1&id=14a0a6e1&scoped=true&lang=scss"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a0a6e1"]])

export default __exports__